import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserInfo, UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class NotAuthorizedGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const user: UserInfo | null = this.userService.getUserInfo();
    if (!user) {
      return true; // No user info, allow access to page (login page, currently, since it this guard is assigned to it)
    }
    return this.router.createUrlTree(['/dashboard']); // User logged in, go to dashboard instead
  }
}
